import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames/bind';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { BaseButton } from '@/scenarios/legacy-player/components/PlayerSkin/parts/BaseButton/BaseButton';
import { BaseButtonColor } from '@/scenarios/legacy-player/components/PlayerSkin/parts/BaseButton/BaseButton.types';
import { BookmarkIcon } from '@/shared/assets/Bookmark';
import { UnbookmarkIcon } from '@/shared/assets/Unbookmark';
import { Button } from '@/shared/components/Button/Button';

import { useSkipWithAnalytics } from '../../../hooks/skin/use-skip';

import styles from './styles.module.css';

const cx = cn.bind(styles);

interface MoviePrerollViewProps {
    prerollDuration: number;
    className: string;
    isInFavorites: boolean | null;
    movieId: number;
    isAnimated: boolean;
    currentFragment: SkippableFragment;
    onBookmarkClick: () => void;
}

export const MoviePrerollView = ({
    prerollDuration,
    className,
    currentFragment,
    isInFavorites,
    movieId,
    isAnimated,
    onBookmarkClick,
}: MoviePrerollViewProps) => {
    const { skip, onSkipButtonShow } = useSkipWithAnalytics(currentFragment);

    return (
        <div className={cx('container', className)} ref={onSkipButtonShow}>
            {movieId && isInFavorites !== null ? (
                <Button
                    variant="accent"
                    size={48}
                    startIcon={
                        isInFavorites ? (
                            <UnbookmarkIcon fill="#FFF" />
                        ) : (
                            <BookmarkIcon fill="#FFF" />
                        )
                    }
                    className={cx('buttonGroup')}
                    onClick={onBookmarkClick}
                    aria-pressed={isInFavorites}
                >
                    {isInFavorites ? (
                        <FormattedMessage
                            id="features.player.17bafd7617daa86ad57471ae343a568c"
                            defaultMessage="Added to watch later"
                            description="Кнопка удаления из избранного"
                        />
                    ) : (
                        <FormattedMessage
                            id="features.player.4c50afb7e9e8feba9653ef01fed506b2"
                            defaultMessage="Add to watch later"
                            description="Кнопка добавления в избранное"
                        />
                    )}
                </Button>
            ) : null}

            <BaseButton
                color={BaseButtonColor.gray}
                isAnimated={isAnimated}
                animationDuration={prerollDuration}
                onClick={skip}
                className={cx('buttonGroup')}
            >
                <FormattedMessage
                    id="features.player.72ef2b9b6965d078e3c7f95487a82d1c"
                    defaultMessage="Skip"
                    description="Текст по умолчанию для группы кнопок для пропуска титров и пр в плеере"
                />
            </BaseButton>
        </div>
    );
};
